module.exports = __webpack_public_path__ + "static/media/compensation-plan.9eb3c735.png";